import { NgModule } from '@angular/core';
import { BaseModule } from '../shared/base.module';
import { HomeRoutesModule } from './home.routes';

//ngx-bootstrap modules
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import {AccordionModule} from "ngx-bootstrap/accordion";
import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import {CollapseModule} from "ngx-bootstrap/collapse";
import {PopoverModule} from "ngx-bootstrap/popover";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {TabsModule} from "ngx-bootstrap/tabs";

import { HomeComponent } from './home.component';
import { SystemAdminComponent } from './system-admin/system-admin.component';
import { ClinicAdminComponent } from './clinic-admin/clinic-admin.component';
import { AssistantComponent } from './assistant/assistant.component';
import { TinymceModule } from 'angular2-tinymce';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NotificationModule } from '../shared/notification/notification.module';
import { DialogModule } from '../dialog/dialog.module';
import { MyDatePickerModule } from 'mydatepicker';
import {
    PERFECT_SCROLLBAR_CONFIG,
    PerfectScrollbarConfigInterface,
    PerfectScrollbarModule
} from 'ngx-perfect-scrollbar';
import { PatientModule } from '../patient/patient.module';
import { SharedPopoverModule } from '../shared/popover/popover.module';
import { UsersModule } from '../users/users.module';
import { SwitchClinicComponent } from './switch-clinic/switch-clinic.component';
import { MATERIALS } from '../app.materials';
import { FormsModule } from '@angular/forms';
import { SwitchClinicService } from './switch-clinic/switch-clinic.service';
import { DocumentsComponent } from './patient/document-dashboard/documents.component';
import { PatientDashboardComponent } from './patient/patient-dashboard.component';
import { B2CAdminComponent } from './b2c-admin/b2c-admin.component';
import { CouponsModule } from '../coupons/coupons.module';
import {VouchersModule} from "../vouchers/vouchers.module";
import {AppointmentsModule} from "../appointments/appointments.module";
import { InsurancePartnerComponent } from './insurance-parner/insurance-partner.component';
import { MentalModule } from './insurance-parner/dashboard/mental-check/mental.module';
import { CommonStrainsComponent } from './insurance-parner/dashboard/common-strains/common-strains.component';
import { DemographicsComponent } from './insurance-parner/dashboard/demographics/demographics.component';
import { PatientsTimelineComponent } from './insurance-parner/dashboard/patients-timeline/patients-timeline.component';
import { HighchartsChartModule } from 'highcharts-angular';
import {MetricsModule} from "./b2c-admin/dashboard/metrics/metrics.module";
import { NpsModule } from './b2c-admin/dashboard/nps/nps.module';
import { EventsModule } from './b2c-admin/dashboard/events/events.module';
import { SuicidalityModule } from './b2c-admin/dashboard/suicidality/suicidality.module';
import { ImpersonateModule } from './b2c-admin/dashboard/impersonate/impersonate.module';
import { PlatformRegistrationCountsModule } from './b2c-admin/dashboard/platform-registration-counts/platform-registration-counts.module';
import { Daterangepicker } from 'ng2-daterangepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { B2CAdminDashboardFiltersModule } from './b2c-admin/dashboard/filters/b2c-admin-filters.module';
import { PackageBillingModule } from './b2c-admin/dashboard/package-billing/package-billing.module';
import { DynamicReportModule } from './b2c-admin/dashboard/dynamic-report/dynamic-report.module';
import { JwtTokenModule } from './b2c-admin/dashboard/jwt-token/jwt-token.module';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
    useBothWheelAxes: true
};

@NgModule({
    imports: [
        MATERIALS,
        FormsModule,
        BaseModule,
        HomeRoutesModule,
        NotificationModule,
        MyDatePickerModule,
        MatSlideToggleModule,
        Daterangepicker,
        TabsModule.forRoot(),
        DialogModule,
        SharedPopoverModule,
        AccordionModule.forRoot(),
        TypeaheadModule.forRoot(),
        ModalModule.forRoot(),
        CollapseModule.forRoot(),
        BsDropdownModule.forRoot(),
        PopoverModule.forRoot(),
        TinymceModule.withConfig({
            menubar: false,
            elementpath: false,
            toolbar: 'bold italic alignleft numlist bullist link formatselect'
        }),
        TooltipModule.forRoot(),
        PerfectScrollbarModule,
        UsersModule,
        CouponsModule,
        VouchersModule,
        ImpersonateModule,
        PackageBillingModule,
        MentalModule,
        AppointmentsModule,
        MetricsModule,
        JwtTokenModule,
        NpsModule,
        EventsModule,
        PlatformRegistrationCountsModule,
        SuicidalityModule,
        HighchartsChartModule,
        DynamicReportModule,
        B2CAdminDashboardFiltersModule
    ],
    declarations: [
        HomeComponent,
        SystemAdminComponent,
        ClinicAdminComponent,
        B2CAdminComponent,
        AssistantComponent,
        PatientDashboardComponent,
        DocumentsComponent,
        SwitchClinicComponent,
        InsurancePartnerComponent,
        CommonStrainsComponent,
        DemographicsComponent,
        PatientsTimelineComponent,
    ],
    providers: [
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        }
    ]
})

export class HomeModule {
}
